import { Avatar } from '@app/components/core/avatar/Avatar'
import { IconButton } from '@app/components/core/button/IconButton'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'

export const RecipientTag = ({
  id,
  name,
  avatar,
  onRemove,
  onClick,
}: {
  id: number
  name: string
  avatar?: string | { src: string }
  onRemove?: VoidFunction
  onClick?: (id: number) => void
}) => {
  return (
    <Row
      onClick={(e) => {
        e.stopPropagation()
        if (onClick) {
          onClick(id)
        }
      }}
      style={{
        padding: '0.25rem 0.5rem 0.25rem 0.25rem',
        gap: '0.5rem',
        borderRadius: '1.25rem',
        border: '1px solid var(--shades-blue-200)',
        alignItems: 'center',
        backgroundColor: 'var(--shades-white)',
        userSelect: onClick ? 'none' : 'auto',
        cursor: onClick ? 'pointer' : 'auto',
      }}
    >
      <Avatar size={'extra-extra-small'} labelSource={name} image={avatar} />
      <Text.Small isBold style={{ textWrap: 'nowrap' }}>
        {name}
      </Text.Small>
      {onRemove && (
        <IconButton
          size="small"
          variant="transparent"
          icon={faXmark}
          onClick={onRemove}
          style={{
            border: 0,
            width: '1rem',
            height: '1rem',
          }}
        />
      )}
    </Row>
  )
}
